import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import { Page } from 'layout/styles/PageLayout.style';

const fullBleedBackground = `
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  z-index: -1;
  background-color: ${colours.neutral[100]};
`;

export const EventPageWrapper = styled(Page)`
  gap: 0;
  background-color: ${colours.neutral[100]};

  &::after {
    content: '';
    display: block;
    min-height: 30px;
    flex-shrink: 0;
    background-color: ${colours.neutral[100]};
    width: 100%;
  }

  > div:first-child {
    background: linear-gradient(
      180deg,
      ${colours.neutral[100]} 44.74%,
      rgba(246, 247, 247, 0.9) 77.95%,
      rgba(246, 247, 247, 0) 100%
    );
  }

  @media (min-width: ${breakpoints.laptop}) {
    > div:first-child {
      background: ${colours.neutral[100]};
    }
  }

  @media (max-width: ${breakpoints.laptop}) {
    padding: 80px 0 0;
  }
`;

export const EventTopSection = styled.div`
  box-sizing: border-box;
  position: relative;
  z-index: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px 20px;

  &::before {
    ${fullBleedBackground}
  }

  @media (max-width: ${breakpoints.laptop}) {
    padding: 0 15px 20px;
  }
`;

export const EventTopSectionInner = styled.div`
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: ${breakpoints.laptop}) {
    max-width: none;
  }
`;

export const EventBottomSection = styled.div`
  box-sizing: border-box;
  position: relative;
  z-index: 0;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 30px;

  &::before {
    ${fullBleedBackground}
  }

  @media (max-width: ${breakpoints.laptop}) {
    padding: 15px 15px;
  }
`;

export const EventBottomSectionInner = styled.div`
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: ${breakpoints.laptop}) {
    max-width: none;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 60px 0;
  width: 100%;
`;
